'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function ($) {

    var methods = {

        init: function init(options) {
            var settings = $.extend({
                btnopen: $('.menu-btn'),
                menu: $('.left-menu'),
                btnclose: $('#close_menu')
            }, options);

            settings.btnopen.click(function (e) {
                e.preventDefault();
                settings.menu.addClass('active');
            });

            settings.btnclose.click(function (e) {
                e.preventDefault();
                settings.menu.removeClass('active');
            });
        }
    };

    $.fn.leftMenu = function (method) {

        if (methods[method]) {
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if ((typeof method === 'undefined' ? 'undefined' : _typeof(method)) === 'object' || !method) {
            return methods.init.apply(this, arguments);
        } else {
            $.error('Метод с именем ' + method + ' не существует для jQuery.tooltip');
        }
    };
})(jQuery);